<div class="grid md:grid-cols-2 gap-6 w-full p-2 lg:p-4">

  <!-- LOGIN TYPE CARD -->
  <div class="p-6 bg-white rounded-2xl shadow-lg border border-gray-200 hover:shadow-xl transition">
    <h3
      class="text-base sm:text-lg lg:text-xl font-semibold text-center bg-gradient-to-r from-[#c19725] to-[#e4b74a] text-transparent bg-clip-text mb-6">
      Select Login Type
    </h3>
    <div class="flex justify-center flex-wrap gap-6 mb-6">
      <div (click)="loginType = 'main'"
        [ngClass]="{'border-[#c19725] bg-[#fff7e0] shadow-md': loginType === 'main', 'border-gray-300': loginType !== 'main'}"
        class="cursor-pointer p-5 rounded-xl border relative transition-all w-40 text-center hover:scale-[1.03]">
        <div *ngIf="loginType === 'main'" class="absolute top-2 right-2"><span class="text-[#c19725] text-xl">✔</span>
        </div>
        <p class="text-sm md:text-base font-semibold text-gray-800">Main Login</p>
        <p class="text-xs text-gray-500 mt-1">Full featured login</p>
      </div>
      <div (click)="loginType = 'simple'"
        [ngClass]="{'border-[#c19725] bg-[#fff7e0] shadow-md': loginType === 'simple', 'border-gray-300': loginType !== 'simple'}"
        class="cursor-pointer p-5 rounded-xl border relative transition-all w-40 text-center hover:scale-[1.03]">
        <div *ngIf="loginType === 'simple'" class="absolute top-2 right-2"><span class="text-[#c19725] text-xl">✔</span>
        </div>
        <p class="text-sm md:text-base font-semibold text-gray-800">Simple Login</p>
        <p class="text-xs text-gray-500 mt-1">Minimal, fast login</p>
      </div>
    </div>
    <div class="flex justify-center">
      <button (click)="saveLoginAndSellType()"
        class="bg-gradient-to-r from-[#c19725] to-[#e4b74a] text-white text-sm px-6 py-2.5 rounded-lg shadow hover:opacity-90">Save
        Login Type</button>
    </div>
  </div>

  <!-- SELL TYPE CARD -->
  <div class="p-6 bg-white rounded-2xl shadow-lg border border-gray-200 hover:shadow-xl transition">
    <h3
      class="text-base sm:text-lg lg:text-xl font-semibold text-center bg-gradient-to-r from-[#c19725] to-[#e4b74a] text-transparent bg-clip-text mb-6">
      Select Sell Type
    </h3>
    <div class="flex justify-center flex-wrap gap-6 mb-6">
      <div (click)="sellType = 'manual'"
        [ngClass]="{'border-[#c19725] bg-[#fff7e0] shadow-md': sellType === 'manual', 'border-gray-300': sellType !== 'manual'}"
        class="cursor-pointer p-5 rounded-xl border relative transition-all w-40 text-center hover:scale-[1.03]">
        <div *ngIf="sellType === 'manual'" class="absolute top-2 right-2"><span class="text-[#c19725] text-xl">✔</span>
        </div>
        <p class="text-sm md:text-base font-semibold text-gray-800">Manual</p>
        <p class="text-xs text-gray-500 mt-1">Enter details manually</p>
      </div>
      <div (click)="sellType = 'auto'"
        [ngClass]="{'border-[#c19725] bg-[#fff7e0] shadow-md': sellType === 'auto', 'border-gray-300': sellType !== 'auto'}"
        class="cursor-pointer p-5 rounded-xl border relative transition-all w-40 text-center hover:scale-[1.03]">
        <div *ngIf="sellType === 'auto'" class="absolute top-2 right-2"><span class="text-[#c19725] text-xl">✔</span>
        </div>
        <p class="text-sm md:text-base font-semibold text-gray-800">Auto</p>
        <p class="text-xs text-gray-500 mt-1">System auto-generate</p>
      </div>
    </div>
    <div class="flex justify-center">
      <button (click)="saveLoginAndSellType()"
        class="bg-gradient-to-r from-[#c19725] to-[#e4b74a] text-white text-sm px-6 py-2.5 rounded-lg shadow hover:opacity-90">Save
        Sell Type</button>
    </div>
  </div>

  <!-- LOGO SETTINGS CARD -->
  <div class="md:col-span-2 p-6 bg-white rounded-2xl shadow-lg border border-gray-200 mt-2">
    <h3
      class="text-base sm:text-lg lg:text-xl font-semibold text-center bg-gradient-to-r from-[#c19725] to-[#e4b74a] text-transparent bg-clip-text mb-6">
      Update Web Logo
    </h3>
    <div class="flex flex-col items-center justify-center gap-6">
      <div (click)="fileInput.click()"
        class="group relative w-64 h-48 border-2 border-dashed border-gray-300 rounded-xl flex items-center justify-center bg-gray-50 cursor-pointer hover:border-[#c19725] transition overflow-hidden">
        <img *ngIf="logoPreview" [src]="logoPreview" class="max-w-full max-h-full object-contain p-2" />
        <div *ngIf="!logoPreview" class="text-center text-gray-400">
          <p class="text-xs">Click to upload brand logo</p>
        </div>
        <div
          class="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition flex items-center justify-center">
          <span class="text-white text-sm">Change Logo</span>
        </div>
      </div>
      <input type="file" #fileInput (change)="onLogoSelected($event)" accept="image/*" class="hidden" />
      <div class="flex gap-4">
        <button (click)="fileInput.click()"
          class="border border-[#c19725] text-[#c19725] text-sm px-6 py-2 rounded-lg hover:bg-orange-50">Choose
          Image</button>
        <button (click)="uploadLogo()" [disabled]="!selectedFile"
          class="bg-gradient-to-r from-[#c19725] to-[#e4b74a] text-white text-sm px-8 py-2.5 rounded-lg shadow disabled:opacity-50">Update
          Logo</button>
      </div>
    </div>
  </div>
</div>